import styled from 'styled-components';

export const Inner = styled.div`
    max-width: 1150px;
    margin: 0 auto;
`;
